/* unplugin-vue-components disabled */import { render } from "./icon_arrow_up.vue?vue&type=template&id=b339d460&scoped=true"
const script = {}

import "./icon_arrow_up.vue?vue&type=style&index=0&id=b339d460&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b339d460"]])

export default __exports__